import axios from "axios";

export const coreapiUrl = import.meta.env.VITE_CORE_API_URL;
 

export const appInstance = axios.create({
  baseURL: coreapiUrl,
});

/* ---------------------- COMMON REQUEST INTERCEPTOR ---------------------- */
const requestInterceptor = (config) => {
  const imo_number = localStorage.getItem("imo_number");
  const token = localStorage.getItem("accessToken");

  // Ensure headers exists
  config.headers = config.headers || {};

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  if (imo_number) {
    config.headers.imo_number = imo_number;
  }

  return config;
};

/* ---------------------- COMMON RESPONSE INTERCEPTOR ---------------------- */
const responseInterceptor = {
  success: (response) => response.data,

  error: (error) => {
    const errorMessage =
      error?.response?.data?.error ||
      error?.message ||
      "Something went wrong.";

    console.error("API Error:", errorMessage);

    const status = error?.response?.status;

    // Token invalid / expired
    if (
      status === 401 ||
      (status === 403 && errorMessage === "invalid_token")
    ) {
      clearAuthData();
      window.location.replace("/login");
    }

    return Promise.reject({
      success: false,
      error: errorMessage,
      data: error?.response?.data,
      status,
    });
  },
};

/* ---------------------- Attach interceptors ---------------------- */
appInstance.interceptors.request.use(
  requestInterceptor,
  (error) => Promise.reject(error)
);

appInstance.interceptors.response.use(
  responseInterceptor.success,
  responseInterceptor.error
);

/* ---------------------- Helpers ---------------------- */
const clearAuthData = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("username");
  localStorage.removeItem("ship_id");
  localStorage.removeItem("reset_new");
  localStorage.removeItem("role");
};

export default appInstance;
